import { Container, Divider, Grid } from '@mui/material';
import { ImageContextProvider } from '../../imageContext';
import { ImageList } from '../ImageList';
import { ImageDetail } from '../ImageDetail';
import Popup from '../Popup';
import { ImageStructureDetail } from '../ImageStructureDetail';
import LoadingSpinner from '../LoadingSpinner';
import { PopupContextProvider } from '../../PopupContext';

export const ImageManagement = (): JSX.Element => {
  return (
    <>
      <ImageContextProvider>
        <PopupContextProvider>
          <LoadingSpinner />
          <Divider sx={{ backgroundColor: '#FFFFFF', height: '5px', color: '#FFFFFF' }} />
          <Container
            sx={{
              paddingLeft: 0,
              paddingRight: 0,
              maxWidth: 'none !important',
              height: '20px',
            }}
          >&nbsp;</Container>
          <Grid size={12} container spacing={2} p={2} bgcolor="#F3F6FE" borderRadius={4} margin={'10px'}>
            <Grid size={8}>
              <ImageList />
            </Grid>
            <Grid size={4}>
              <Grid>
                <ImageDetail />
              </Grid>
              <Grid>
                <br />
                <div>
                  <hr
                    style={{
                      border: 0,
                      borderTop: '1px solid #d3d3d3',
                      margin: 0,
                      width: '100%',
                    }}
                  />
                </div>
                <br />
                <ImageStructureDetail />
              </Grid>
            </Grid>
          </Grid>

          <Popup initialTrigger={false} />
        </PopupContextProvider>
      </ImageContextProvider>
    </>
  );
};
